import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import BaseCheckbox from '@r1-frontend/ui-react/components/controls/baseCheckbox';
import InputSimple, { phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
// @ts-ignore
import { FlexBoxCol, FlexBoxRow } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
// @ts-ignore
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import PopupWithHeader from '@r1-frontend/ui-react/components/popups/popupWithHeader';
import Select from '@r1-frontend/ui-react/components/select/select';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const InputPhone = phoneDecorator(InputSimple);

export const PopupBody = styled.div`
  padding-left: 60px;
  padding-right: 100px;

  @media (max-width: 480px) {
    padding-left: 1.5rem;
    padding-right: 2rem;
  }
`;

export const Phone = styled(InputPhone)`
  margin-bottom: 20px;
  width: 100%;
`;

export const CitySelect = styled(Select)`
  margin-bottom: 20px;
`;

export const ManiaPopup = styled(PopupWithHeader)`
  @media (max-width: 768px) {
    min-height: inherit !important;
  }
`;

export const MainDescription = styled.div`
  margin-top: 35px;
  ${FONTS.L};

  @media (max-width: 480px) {
    ${FONTS.S};
  }
`;

export const Section = styled.div`
  width: 100%;
  display: block;
`;

export const FlexBoxRowMargin = styled(FlexBoxRow)`
  margin-top: 20px;
  margin-bottom: 40px;
`;

export const CheckboxTextMin = styled(BaseCheckbox)`
  ${FONTS.XXS};
  color: ${COLORS.darkGrey};
`;

export const FormGrid = styled(GridContainer)`
  padding-left: 0;
  padding-right: 0;
`;

export const BtnDescriptionCol = styled(FlexBoxCol)`
  display: flex;
`;

export const BtnDescription = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  ${FONTS.XXS};
  color: ${COLORS.darkGrey};
`;

export const SecondaryDescription = styled.div`
  margin-top: 20px;
  margin-bottom: 40px;
  ${FONTS.S};

  @media (max-width: 480px) {
    ${FONTS.S};
  }
`;

export const FormHeader = styled.div`
  margin-bottom: 15px;
  ${FONTS.S};
  display: flex;
  align-items: center;
`;
